export const ENV = { ENV: "dev", HOST_BACKEND: "https://api.dev.dareresponse.com" };